import * as React from 'react';
import { DropdownTabbed, ContentEditableTinyMCE } from '../';
import { IOutput, SetOutputMethodType, DOMHelper, IFieldConfig, OutputsHelper, ModalHelper, IValueOption, EOutputLookupContext, IFieldError, IAction, CRMFieldType, ComponentHelper } from '../../helpers';
import { TextField, IDropdownOption, Button, ButtonType, Label, Checkbox } from 'office-ui-fabric-react';
import { PROPERTIES_OUTPUTS_DEBOUNCE_NUMBER } from '../../constants';
import ReactDOM = require('react-dom');
import { EntityFieldTinyMCE } from '../output-reference/entity-field-tinymce';
import { Prompt } from 'react-router'
import { ItemHelper } from '../../helpers/items';

declare var jQuery;

interface IItemHandler {
    addItem: () => void;
    updateItemLabel: (index: number, label: string) => void;
    updateItemURL: (index: number, value: string) => void;
    updateItemIcon: (index: number, value: string) => void;
    removeItem: (index: number) => void;
    moveItem: (fromIndex: number, toIndex: number) => void;
};

interface IFieldHandler {
    addField: () => void;
    addFieldFromMetadata?: (fieldName: string, fieldValue: string, fieldType: number, fieldRequired?: boolean, friendlyName?: string) => void;
    updateFieldName: (fieldIndex: number, newName: string) => void;
    updateFieldValue: (fieldIndex: number, value: string) => void;
    updateValueOptionsFieldValue: (fieldIndex: number, value: string) => void;
    updateFieldType: (fieldIndex: number, key: number) => void;
    updateFieldRequired: (fieldIndex: number, key: boolean) => void;
    deleteField: (fieldIndex: number) => void;
}

interface IOutputHandler {
    updateOutput: (i: number, name: string) => void;
    outputBlur: (i: number, name: string, staticName: string, logicalName: string) => void;
    updateSelectedGlobalOutput: (index: number, key: string) => void;
    setAdvancedSettingsIndex?: (index: number) => void;
    updateSelectedOutputType?: (index: number, type: number) => void;
    updateOutputStaticName?: (index: number, staticName: string) => void;
    updateOutputLogicalName: (index: number, logicalName: string) => void;
    updateOutputDefaultValue: (index: number, defaultValue: string) => void;
    updateGetRecordOutputDefaultValue?: (logicalName: string, defaultValue: string) => void;
    addActionOutput?: () => void;
    addActionOutputArray?: (output: IOutput) => void;
    removeActionOutputArray?: (output: IOutput) => void;
    deleteActionOutput?: (index: number) => void;
}

interface IProps {
    action?: IAction;
    outputs: IOutput[];
    fieldTypes?: IDropdownOption[];
    fields?: IFieldConfig[];
    fieldError?: IFieldError;
    entityOutputs?: IOutput[];
    entityFields?: IDropdownOption[];
    fieldHandler?: IFieldHandler;
    outputDropdownOptions?: IDropdownOption[];
    globalOutputDropdownOptions?: IDropdownOption[];
    outputTypeDropdownOptions?: IDropdownOption[];
    outputValueDropdownOptions?: IDropdownOption[];
    options?: IDropdownOption[];
    itemHandler?: IItemHandler;
    overIndex?: number;
    HasUIDefinedOutputs?: boolean;
    outputHandler?: IOutputHandler;
    outputOptions?: IDropdownOption[];
    advancedSettingsIndex?: number;
    sharedJourneyMode?: boolean;
    showImageUrlField?: boolean;
    displayOnlyOutputs?: boolean;
    fieldElements?: JSX.Element[];
};

export class ListOfItems extends React.Component<IProps, any> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            showMore: false
        }
        this.changeShowMore = this.changeShowMore.bind(this);
    }

    changeShowMore(showMenuVal: boolean) {
        this.setState({
            showMore: showMenuVal,
        });
    }

    // getEditorText(val: string) {

    //     if (!val)
    //         return '';

    //     const editorContent = JSON.parse(val).markup;
    //     let contentElement = document.createElement('div');
    //     contentElement.innerHTML = editorContent;
    //     let editorText = contentElement.innerText ? contentElement.innerText.trim() : '';
    //     editorText = editorText.replace(/\u200B/g, ''); //remove all zero-width spaces
    //     return editorText;
    // }

    private inputTimeout: any[];
    private visibleFieldCount: number = 5;
    private debounceSetOutput = (methodType: SetOutputMethodType, name: string, value: any, fieldIndex: number) => {

        let { fieldHandler, outputHandler } = this.props;
        if (!this.inputTimeout) {
            this.inputTimeout = [];
        }

        if (this.inputTimeout[methodType]) {
            clearTimeout(this.inputTimeout[methodType]);
        }

        this.inputTimeout[methodType] = setTimeout(() => {
            switch (methodType) {
                case SetOutputMethodType.UpdateFieldName:
                    fieldHandler.updateFieldName(fieldIndex, name)
                    break;
                case SetOutputMethodType.UpdateItemTitle:
                    this.props.itemHandler.updateItemLabel(fieldIndex, value);
                    break;
                case SetOutputMethodType.UpdateItemUrl:
                    this.props.itemHandler.updateItemURL(fieldIndex, value);
                    break;
                case SetOutputMethodType.UpdateItemIcon:
                    this.props.itemHandler.updateItemIcon(fieldIndex, value);
                    break;
                case SetOutputMethodType.UpdateOutputStaticName:
                    this.props.outputHandler.updateOutputStaticName(fieldIndex, name);
                    break;
                case SetOutputMethodType.UpdateOutputLogicalName:
                    this.props.outputHandler.updateOutputLogicalName(fieldIndex, name);
                    break;
                case SetOutputMethodType.UpdateOutput:
                    this.props.outputHandler.updateOutput(fieldIndex, name);
                    break;
            }
        }, PROPERTIES_OUTPUTS_DEBOUNCE_NUMBER);
    }

    clickAddOption = () => {
        this.props.itemHandler.addItem();
        ModalHelper.scrollToBottom();
    }

    setSelectedKey(res: any, updateFieldName: number, key: string, emptyString: string, fieldIndex: number) {
        this.debounceSetOutput(updateFieldName, key, "", fieldIndex)
        return res;
    }

    getFieldsHtml = (field: IFieldConfig, fieldIndex: number): JSX.Element => {

        let { fieldHandler, fieldTypes, outputOptions } = this.props;
        let tabIndex = 750 + fieldIndex * 4;

        let fieldsToLoad =
            <tr key={'field_' + fieldIndex + '_'} className="values-field">
                <td className="field-name">

                    <Label className="field-label" title={field.FriendlyName ? field.FriendlyName : field.FieldName}>{field.FriendlyName ? field.FriendlyName : field.FieldName}</Label><span className='field-label-required'>{field.FieldRequired ? '*' : null}</span>

                </td>
                <td>
                    {
                        field.ValueOptions ?
                            <div className="value-options">

                                <DropdownTabbed
                                    tabIndex={1}
                                    options={field.ValueOptions}
                                    required={true}
                                    label={null}
                                    selectedKey={field.FieldValue}
                                    onChanged={
                                        (val) => {
                                            fieldHandler.updateFieldValue(fieldIndex, val.key.toString());
                                        }
                                    } />
                                <EntityFieldTinyMCE
                                    tabIndex={tabIndex + 2}
                                    value={field.ValueOptionsFieldValue}
                                    onBlur={
                                        (val) => {

                                            // handle required validation for transient attribut
                                            if (field.FieldName.indexOf('_transient_') !== -1) {
                                                const transientPrefix = field.FieldName.split('_transient_')[0];
                                                const anotherTransientField = this.props.fields.filter(x => x.FieldName.indexOf(transientPrefix) !== -1)
                                                    .filter(y => y.FieldName !== field.FieldName)[0];
                                                const editorText = ComponentHelper.getEditorText(val);


                                                if (!editorText) {
                                                    fieldHandler.updateValueOptionsFieldValue(fieldIndex, "");
                                                    if (!ComponentHelper.getEditorText(anotherTransientField.ValueOptionsFieldValue)) {
                                                        fieldHandler.updateFieldRequired(this.props.fields.indexOf(this.props.fields.filter(x => x.FieldName.indexOf(transientPrefix) !== -1)
                                                            .filter(y => y.FieldName !== field.FieldName)[0]), true);
                                                        return;
                                                    }
                                                    fieldHandler.updateFieldRequired(this.props.fields.indexOf(this.props.fields.filter(x => x.FieldName === field.FieldName)[0]), false);
                                                    return;
                                                }

                                                !ComponentHelper.getEditorText(anotherTransientField.ValueOptionsFieldValue) ?
                                                    fieldHandler.updateFieldRequired(this.props.fields.indexOf(anotherTransientField), false)
                                                    :
                                                    fieldHandler.updateFieldRequired(this.props.fields.indexOf(this.props.fields.filter(x => x.FieldName === field.FieldName)[0]), true);
                                            }

                                            fieldHandler.updateValueOptionsFieldValue(fieldIndex, val);
                                        }
                                    }
                                    richText={false}
                                    outputOptions={outputOptions || []}
                                    singleLine={true}
                                    readonly={false}
                                    outputLookupContext={EOutputLookupContext.NotSpecified}
                                    isEntityProperty={true}

                                />
                            </div>

                            // selectedKey={(output.StaticName || '').toString()}
                            // onChanged={(val) => this.debounceSetOutput(SetOutputMethodType.UpdateOutputStaticName, val.key.toString(), "", i)} />
                            :
                            <EntityFieldTinyMCE
                                tabIndex={tabIndex + 2}
                                value={field.FieldValue}
                                onBlur={
                                    (val) => {

                                        // handle required validation for transient attribut
                                        if (field.FieldName.indexOf('_transient_') !== -1) {
                                            const transientPrefix = field.FieldName.split('_transient_')[0];
                                            const anotherTransientField = this.props.fields.filter(x => x.FieldName.indexOf(transientPrefix) !== -1)
                                                .filter(y => y.FieldName !== field.FieldName)[0];
                                            const editorText = ComponentHelper.getEditorText(val);


                                            if (!editorText) {
                                                fieldHandler.updateFieldValue(fieldIndex, "");
                                                if (!ComponentHelper.getEditorText(anotherTransientField.FieldValue)) {
                                                    fieldHandler.updateFieldRequired(this.props.fields.indexOf(this.props.fields.filter(x => x.FieldName.indexOf(transientPrefix) !== -1)
                                                        .filter(y => y.FieldName !== field.FieldName)[0]), true);
                                                    return;
                                                }
                                                fieldHandler.updateFieldRequired(this.props.fields.indexOf(this.props.fields.filter(x => x.FieldName === field.FieldName)[0]), false);
                                                return;
                                            }

                                            !ComponentHelper.getEditorText(anotherTransientField.FieldValue) ?
                                                fieldHandler.updateFieldRequired(this.props.fields.indexOf(anotherTransientField), false)
                                                :
                                                fieldHandler.updateFieldRequired(this.props.fields.indexOf(this.props.fields.filter(x => x.FieldName === field.FieldName)[0]), true);
                                        }

                                        fieldHandler.updateFieldValue(fieldIndex, val);
                                    }
                                }
                                richText={false}
                                outputOptions={outputOptions || []}
                                singleLine={true}
                                readonly={false}
                                outputLookupContext={EOutputLookupContext.NotSpecified}
                                isEntityProperty={true}

                            />
                    }
                </td>
            </tr>

        return (
            fieldsToLoad
        );

    }

    optionHtml = (option: IValueOption, i: number): JSX.Element => {

        let tabIndex = 500 + i * 3;

        //TODO: fill in max file size and max image dimensions
        let imageUrlTooltip = `
            <ul>
                <li>Max file size: 50KB</li>
                <li>Max image dimensions: 128 x 128</li>
                <li>Allowed file types: jpeg, gif, png</li>
                <li>Must be a publicly accessible internet url</li>
            </ul>
        `;

        let html: JSX.Element = (
            <div key={"option_" + i}
                className={"option clearfix" + (this.props.overIndex === i ? ' drag-over' : '') + (this.props.showImageUrlField ? ' has-image-url-field' : '')}
                onDrop={(e) => ItemHelper.drop(e, i)}
                onDragOver={(e) => ItemHelper.allowDrop(e, i)}>

                <Button buttonType={ButtonType.icon} icon="Move"
                    tabIndex={-1}
                    title="Move option"
                    className="option-move"
                    draggable={true}
                    onDragStart={(e) => ItemHelper.drag(e, i)}
                    onDragEnd={(e) => ItemHelper.drop(e, null)} />

                <TextField
                    tabIndex={tabIndex + 2}
                    className="label-field"
                    label="Title" value={option.text}
                    onChanged={(e) => this.debounceSetOutput(SetOutputMethodType.UpdateItemTitle, "", e, i)}
                />
                <TextField
                    tabIndex={tabIndex + 3}
                    className="value-field"
                    label="URL" value={option.url.toString()}
                    onChanged={(e) => this.debounceSetOutput(SetOutputMethodType.UpdateItemUrl, "", e, i)}
                />
                <TextField
                    tabIndex={tabIndex + 4}
                    className="value-field"
                    label="Icon" value={option.icon.toString()}
                    onChanged={(e) => this.debounceSetOutput(SetOutputMethodType.UpdateItemIcon, "", e, i)}
                />

                <span className="property-info">
                    <i> Please add an icon class from <a href="https://fontawesome.com/v4/icons" target="_blank">here</a>. Example: <b>fa-home</b></i>
                </span>


                {/* {this.props.showImageUrlField &&
                    <div className="image-url-field-wrapper">
                        <Label className="image-url-field-label">Image Url</Label>
                        <i className="ms-Icon ms-Icon--Info x-hidden-focus image-url-field-info" title={
                            imageUrlTooltip} aria-hidden="true" data-toggle="tooltip" data-placement="top" data-html="true">
                        </i>
                        <TextField
                            className="image-url-field"
                            tabIndex={tabIndex + 4}
                            label={null}
                            value={option.imageUrl}
                            onChanged={(e) => this.props.itemHandler.updatItemIcon(i, e)}
                        />
                    </div>
                } */}

                <Button
                    tabIndex={tabIndex + 5}
                    buttonType={ButtonType.icon} icon="Delete"
                    className='delete-option-button'
                    onClick={() => this.props.itemHandler.removeItem(i)}
                    title="Delete option"
                />

            </div>
        );

        return html;

    }

    defaultOption: IDropdownOption[] = [{ text: '-', key: '' }];

    validateLogicalInput = (value) => {
        return !OutputsHelper.isValidOutputLogicalName(value) ? "Logical name must contain only lower case letters, numbers, full stop (.) or underscore (_)" : '';
    }

    uiDefinedOutputHtml = (output: IOutput, i: number): JSX.Element[] => {

        let { action, outputHandler, globalOutputDropdownOptions, outputTypeDropdownOptions, advancedSettingsIndex, outputDropdownOptions, outputValueDropdownOptions } = this.props;

        let baseTabIndex = 1 + i * 7;
        // let outputType;
        // switch(output.Type){
        //     case CRMFieldType.SingleLineOfText:
        //         outputType = outputTypeDropdownOptions.
        // }
        let localOutputTabIndex = baseTabIndex + 1;
        let outputTypeTabIndex = baseTabIndex + 2;
        let globalOutputTabIndex = baseTabIndex + 3;
        let advancedButtonTabIndex = baseTabIndex + 4;
        let deleteButtonTabIndex = baseTabIndex + 5;
        let logicalNameTabIndex = baseTabIndex + 6;
        let defaultValueTabIndex = baseTabIndex + 7;
        let isOutputValue = (action.OutputValues && action.OutputValues.filter(x => x.LogicalName === output.LogicalName).length) ? true : false;
        let html: JSX.Element[] = ([
            <tr key={"output_" + i} className="output output-row ui-defined">
                <td className="local-output" title={output.IsImmutable ? output.Name : null}>
                    {
                        output.IsImmutable ?
                            <TextField
                                disabled={true}
                                label={null}
                                tabIndex={localOutputTabIndex}
                                value={output.Name}
                                title={output.Name}
                                onBlur={(e) => outputHandler.outputBlur(i, output.Name, output.StaticName, output.LogicalName)}
                                onChanged={(e) => this.debounceSetOutput(SetOutputMethodType.UpdateOutput, e, "", i)} />
                            :
                            <TextField
                                label={null}
                                tabIndex={localOutputTabIndex}
                                value={output.Name}
                                title={output.Name}
                                onBlur={(e) => outputHandler.outputBlur(i, output.Name, output.StaticName, output.LogicalName)}
                                onChanged={(e) => this.debounceSetOutput(SetOutputMethodType.UpdateOutput, e, "", i)} />
                    }
                </td>
                {
                    outputValueDropdownOptions &&
                    <td>
                        <DropdownTabbed
                            tabIndex={outputTypeTabIndex}
                            options={outputValueDropdownOptions}
                            required={true}
                            label={null}
                            selectedKey={(output.StaticName || '').toString()}
                            onChanged={(val) => this.debounceSetOutput(SetOutputMethodType.UpdateOutputStaticName, val.key.toString(), "", i)} />
                    </td>
                }
                <td className="global-output">
                    <DropdownTabbed tabIndex={globalOutputTabIndex}
                        options={this.defaultOption.concat(globalOutputDropdownOptions)}
                        label={null}
                        selectedKey={(output.GlobalOutputId || '').toString()} required={output.IsRequiredGlobalOutput}
                        onChanged={(val) => outputHandler.updateSelectedGlobalOutput(i, val.key.toString())} />
                </td>
                {/* <td>
                    <DropdownTabbed
                        tabIndex={outputTypeTabIndex}
                        options={outputTypeDropdownOptions}
                        label={null}
                        selectedKey={output.ValueType}
                        disabled={!!outputValueDropdownOptions}
                        onChanged={(val) => outputHandler.updateSelectedOutputType(i, +val.key)} />
                </td> */}
                <td>
                    <EntityFieldTinyMCE
                        richText={false}
                        outputOptions={outputDropdownOptions || []}
                        onBlur={v => {
                            isOutputValue ?
                                outputHandler.updateGetRecordOutputDefaultValue(output.LogicalName, v) :
                                null;
                        }}
                        singleLine={true}
                        tabIndex={defaultValueTabIndex}
                        value={output.PrepopulatedValue}
                        readonly={output.DisablePrepopulatedValue}
                        outputLookupContext={EOutputLookupContext.NotSpecified}
                        isEntityProperty={true}
                        disabled={!isOutputValue}
                    />

                </td>
                {/* <td className="delete-output">
                    <Button icon="Delete" tabIndex={deleteButtonTabIndex} buttonType={ButtonType.icon} onClick={() => { outputHandler.deleteActionOutput(i); }} title='Delete Output' />
                </td> */}
                <td className="checkbox-output">
                    <Checkbox disabled={false} name={'test'} checked={isOutputValue}
                        onChange={(e, isChecked: boolean) => {
                            if (isOutputValue) {
                                outputHandler.updateGetRecordOutputDefaultValue(output.LogicalName, null)
                                outputHandler.removeActionOutputArray(output)
                            } else {
                                outputHandler.addActionOutputArray(output);
                            }
                        }} />
                </td>
            </tr>,
            i === advancedSettingsIndex && <tr>
                <td colSpan={5}>
                    <div className="output-property-panel">
                        <div className="advanced-settings-heading">Advanced settings for output: '{output.Name}'</div>
                        <TextField
                            tabIndex={logicalNameTabIndex}
                            label={'CRM Logical Name'}
                            value={output.LogicalName || ''}
                            className="logical-name"
                            onBlur={(e) => outputHandler.outputBlur(i, output.Name, output.StaticName, output.LogicalName)}
                            onChanged={(e) => this.debounceSetOutput(SetOutputMethodType.UpdateOutputLogicalName, e, "", i)}
                            onGetErrorMessage={(value) => this.validateLogicalInput(value)}
                        />
                        <Label className="default-value-label">Default Value</Label>
                        <ContentEditableTinyMCE
                            richText={false}
                            outputOptions={outputDropdownOptions}
                            onBlur={v => outputHandler.updateOutputDefaultValue(i, v)}
                            singleLine={true}
                            tabIndex={defaultValueTabIndex}
                            value={output.PrepopulatedValue}
                            readonly={output.DisablePrepopulatedValue}
                            outputLookupContext={EOutputLookupContext.NotSpecified}
                        />
                    </div>
                </td>
            </tr>
        ]
        );

        return html;

    }

    fixedOutputHTML = (output: IOutput, i: number): JSX.Element[] => {

        let { outputHandler, globalOutputDropdownOptions, advancedSettingsIndex, outputDropdownOptions } = this.props;

        let baseTabIndex = 0 + i * 5;
        let localOutputTabIndex = baseTabIndex + 1;
        let globalOutputTabIndex = baseTabIndex + 2;
        let advancedButtonTabIndex = baseTabIndex + 3;
        let logicalNameTabIndex = baseTabIndex + 4;
        let defaultValueTabIndex = baseTabIndex + 5;

        let html: JSX.Element[] = ([
            <tr key={"output_" + i} className="output output-row">
                <td className="label">
                    {
                        output.StaticName
                    }
                </td>
                <td className="default-value">
                    <ContentEditableTinyMCE
                        richText={false}
                        outputOptions={outputDropdownOptions}
                        onBlur={v => outputHandler.updateOutputDefaultValue(i, v)}
                        singleLine={true}
                        tabIndex={defaultValueTabIndex}
                        value={output.PrepopulatedValue}
                        readonly={output.DisablePrepopulatedValue}
                        outputLookupContext={EOutputLookupContext.NotSpecified}
                    />
                </td>
                <td className="global-output">
                    <DropdownTabbed tabIndex={globalOutputTabIndex} options={this.defaultOption.concat(globalOutputDropdownOptions)} label={null}
                        selectedKey={(output.GlobalOutputId || '').toString()} required={output.IsRequiredGlobalOutput}
                        onChanged={(val) => outputHandler.updateSelectedGlobalOutput(i, val.key.toString())} />
                </td>
                <td className="advanced-settings">
                    <Button
                        tabIndex={advancedButtonTabIndex}
                        onClick={() => outputHandler.setAdvancedSettingsIndex(i)}
                    >...</Button>
                </td>
            </tr>,
            i === advancedSettingsIndex && <tr>
                <td colSpan={4}>
                    <div className="output-property-panel">
                        <div className="advanced-settings-heading">Advanced settings for output: '{output.StaticName}'</div>
                        <TextField
                            tabIndex={logicalNameTabIndex}
                            label={'CRM Logical Name'}
                            className="logical-name"
                            value={output.LogicalName || ''}
                            onBlur={(e) => outputHandler.outputBlur(i, output.Name, output.StaticName, output.LogicalName)}
                            onChanged={(e) => this.debounceSetOutput(SetOutputMethodType.UpdateOutputLogicalName, e, "", i)}
                            onGetErrorMessage={(value) => this.validateLogicalInput(value)}
                        />
                        <TextField
                            label="Local Output"
                            className="local-output"
                            tabIndex={localOutputTabIndex}
                            value={output.Name}
                            onBlur={(e) => outputHandler.outputBlur(i, output.Name, output.StaticName, output.LogicalName)}
                            onChanged={(e) => this.debounceSetOutput(SetOutputMethodType.UpdateOutput, e, "", i)} />
                    </div>
                </td>
            </tr>
        ]
        );

        return html;

    }

    outputHtml = (output: IOutput, i: number): JSX.Element[] => {

        let { sharedJourneyMode, outputHandler } = this.props;

        if (this.props.HasUIDefinedOutputs) {
            return this.uiDefinedOutputHtml(output, i);
        }
        else if (sharedJourneyMode) {
            return [<tr>
                <td>{output.OutputLabelFromSharedJourney || output.Name}</td>
                <td>
                    <TextField
                        label={null}
                        value={output.LogicalName || ''}
                        onBlur={(e) => outputHandler.outputBlur(i, output.Name, output.StaticName, output.LogicalName)}
                        onChanged={(e) => {
                            outputHandler.updateOutput(i, e)
                        }
                        } />
                </td>
            </tr>];
        }
        else {
            return this.fixedOutputHTML(output, i);
        }

    };

    headerHTML = (): JSX.Element => {

        let { action, HasUIDefinedOutputs, sharedJourneyMode } = this.props;

        if (HasUIDefinedOutputs) {
            return (
                <tr>
                    <th className="local-output" title="The name of the local output variable">Local Output</th>
                    {
                        this.props.outputValueDropdownOptions &&
                        <th className="output-field" title="The field name expected from the exernal provider">Output Field</th>
                    }
                    <th className="global-output" title="The global output, which can be read or updated by other components (optional)">Global Output</th>
                    {/* <th className="output-type" title="The type of the output variable">Output Type</th> */}
                    <th className="delete-output">Default Value </th>
                    {(action.ActionType && action.ActionType.NameType.toLowerCase() === 'get record') ?
                        <th className="checkbox-output">Is Output </th> :
                        null}
                </tr>
            );
        }
        else if (sharedJourneyMode) {
            return <tr>
                <th>Shared Output Name</th>
                <th>Local Output Name</th>
            </tr>
        }
        else {
            return (
                <tr>
                    <th title="The name of the output">Output Name</th>
                    <th title="The default value of the variable">Default Value</th>
                    <th title="The global output, which can be read or updated by other components (optional)">Global Output</th>
                </tr>
            );
        }

    }

    public componentDidMount() {

        let { fields, options, entityFields, fieldHandler } = this.props;
        DOMHelper.setDropdownPropertyTabIndex();
        DOMHelper.focusOnFirstModalTabbableControl();
        jQuery('.image-url-field-info').tooltip();

        if (!fields && !options) {
            ModalHelper.scrollToBottom();
        }
        setTimeout(() => {
            // Updating the field value in the state
            // this.setState({ fieldValue: 'Initial value loaded' });
        }, 2000);

    }

    public render() {
        this.visibleFieldCount = 5;
        let { props } = this;
        let filteredOutputs = (props.action && props.action.ActionType && props.action.ActionType.NameType.toLowerCase() === 'get record' && props.entityOutputs) ?
            props.entityOutputs.filter((value) => !value.IsHidden) :
            props.outputs && props.outputs.filter((value) => !value.IsHidden);

        let outputs = filteredOutputs && filteredOutputs.map(this.outputHtml);

        let items: JSX.Element[] = props.options.map(this.optionHtml);
        const hasError = props.fields ? Object.keys(props.fields).indexOf('Error') !== -1 : null;

        // load fields to display
        let fields: JSX.Element[];
        if (!hasError) {
            fields = props.fields ?
                props.fields.map(this.getFieldsHtml)
                : null;
        } else {
            fields = null;
        }

        let fieldErrorExists: IFieldError = props.fieldError;
        let noFieldsCss = (!props.fields || props.fields.length === 0) ? " nofields" : "";
        let noOutputCss = (!props.outputs || props.outputs.length === 0) ? " nooutputs" : "";
        return (
            <div className={"values-wrapper outputs" + noOutputCss}>

                {fieldErrorExists ?
                    <span className="entity-debounce-error-messages"> {fieldErrorExists.ErrorMessage}</span> : null}
                <div key="items_head" className="options">
                    {items}
                    <div><Button tabIndex={500} icon="Add" onClick={this.clickAddOption} title="Add item" /></div>
                </div>

            </div >)

    }

}



// WEBPACK FOOTER //
// ./source/ts/components/common/list-of-items.tsx